export default "__VITE_ASSET__0fa47d22__"